import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from './index.module.scss'

const MAP_INFO = [
  'AUDIT_PROOF',
  'DATA_FROM',
  'BUSINESS_DATA',
  'ORIGINAL_COMPANY',
]

export const IntroductionBlock = () => {
  return (
    <Element
      className={['p2 mt2', classes.blockContainer].join(' ')}
      style={{ backgroundColor: '#fff' }}
    >
      <Element style={{ color: '#3A414B', lineHeight: 1.6 }}>
        <div>
          <Translate value="internationalSearch.OUR" />
          &nbsp; <span className="fw600">International Search</span>&nbsp;
          <Translate value="internationalSearch.PROVIDES_A_SEAMLESS" />
        </div>
        <ul className={['my2 ml1', classes.blockList].join(' ')}>
          <Translate value="internationalSearch.WE_PROVIDES" />
          {MAP_INFO.map((item) => (
            <li key={item}>
              <Translate value={`internationalSearch.${item}`} />
            </li>
          ))}
        </ul>
        <div>
          <Translate value="internationalSearch.WE_ARE_ALWAYS" />
        </div>
      </Element>
    </Element>
  )
}
